<article>

    <kal-form-field class="gup-C-formFieldSize--bottomNull">

        <app-beneficiary-picker (selectedOnClick)="selectBeneficiary($event)"
                                label="Bénéficiaire"
                                [showMatricules]="showMatricules"
                                clearOnPick
                                [filtersFunction]="filtersFunction"
                                [kalSelectOnPick]="false">
        </app-beneficiary-picker>

    </kal-form-field>

    <ng-content></ng-content>

</article>

<article>

    <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

        <label>
            {{label}}
        </label>

        <a *ngIf="datasource?.beneficiaryList | arrayNotEmpty"
           class="gup-O-link -secondary"
           (click)="deleteAll()">
            <span class="small">Tout supprimer</span>
        </a>

    </div>

    <kal-table #table
               [columns]="datasource.columns"
               [dataSource]="beneficiaryList"
               virtual
               virtualItemSize="30"
               virtualViewPortHeight="500px"
               actionable>

        <tr *kalHeaderRowDef kal-header-row></tr>

        <ng-container [kalColumn]="table.actionColumnName">
            <td *kalBodyCell="let element">
                <diV>
                    <a class="gup-O-link -secondary"
                       (click)="datasource?.deleteBeneficiary(element.Id)">
                        Supprimer
                    </a>
                </diV>
            </td>
        </ng-container>

    </kal-table>

</article>
